module.exports = __webpack_public_path__ + "img/MGH-Nakasu-2-2440x1172.2845dc2d.jpg";